import React from 'react';
import { Search, Filter, Calendar } from 'lucide-react';

interface LogFilterProps {
    filterType: string;
    setFilterType: (val: string) => void;
    startDate: string;
    setStartDate: (val: string) => void;
    endDate: string;
    setEndDate: (val: string) => void;
    searchTerm: string;
    setSearchTerm: (val: string) => void;
    onSearch: () => void;
}

const LogFilter: React.FC<LogFilterProps> = ({
    filterType, setFilterType,
    startDate, setStartDate,
    endDate, setEndDate,
    searchTerm, setSearchTerm,
    onSearch
}) => {
    return (
        <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm space-y-4">
            <div className="flex flex-wrap items-center gap-4">
                {/* Type Filter */}
                <div className="flex items-center gap-2">
                    <Filter size={16} className="text-slate-400" />
                    <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 font-bold text-slate-700"
                    >
                        <option value="all">전체 활동</option>
                        <option value="api_usage">API 사용</option>
                        <option value="schedule_change">일정 변경</option>
                    </select>
                </div>

                {/* Date Range */}
                <div className="flex items-center gap-2">
                    <Calendar size={16} className="text-slate-400" />
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 text-slate-600"
                    />
                    <span className="text-slate-400">~</span>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 text-slate-600"
                    />
                </div>

                {/* Search */}
                <div className="flex-1 flex items-center relative min-w-[250px]">
                    <Search className="absolute left-3 text-slate-400" size={16} />
                    <input
                        type="text"
                        placeholder="검색어 입력 (이름, 내용, API 키 뒷자리 등)"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                    />
                </div>

                <button
                    onClick={onSearch}
                    className="px-5 py-2 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 transition-colors shadow-sm active:scale-95"
                >
                    조회
                </button>
            </div>
        </div>
    );
};

export default LogFilter;
